const CustomElementRegistry_ = CustomElementRegistry
const Element_ = Element
const HTMLElement_ = HTMLElement
const customElements_ = customElements

export {
  CustomElementRegistry_ as CustomElementRegistry,
  Element_ as Element,
  HTMLElement_ as HTMLElement,
  customElements_ as customElements,
}
